export enum SystemTriggers {
    LOGIN = 'Login',
    FIRST_LOGIN = 'First Login'
}
